import { createRouter, createWebHistory } from "vue-router";

import Dashboard from "@/views/Dashboard.vue";
import Participation from "@/views/Participation.vue";
import Reports from "@/views/Reports.vue";
import Programs from "@/views/Programs.vue";
import Program from "@/views/Program.vue";
import StateContacts from "@/views/StateContacts.vue";
import Deliverers from "@/views/Deliverers.vue";
import Coordinators from "@/views/Coordinators.vue";
import Vouchers from "@/views/Vouchers.vue";
import LogoutViewVue from "@/views/LogoutView.vue";
import PageNotFound from "@/components/404.vue";
import ProgramRegistration from "@/views/ProgramRegistration.vue";
import ProgramParticipantsSelection from "@/views/ProgramParticipantsSelection.vue";
import ProgramParticipants from "@/views/ProgramParticipants.vue";
import ProgramParticipantsEmail from "@/views/ProgramParticipantsEmail.vue";
import ProgramParticipantsSendEmail from "@/components/common/EmailForm.vue";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      name: "Participation-root",
      redirect: (to) => {
        return { name: "Dashboard" }
      }
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      component: Dashboard
    },
    {
      path: "/participation",
      name: "Participation-par",
      component: Programs,
    },
    {
      path: "/participation/programs",
      name: "Participation",
      component: Programs,
    },
    {
      path: "/participation/program/:programUID?/:d?",
      name: "ParticipationProgram",
      component: Program,
    },
    {
      path: "/participation/program-registration/:programUID?",
      name: "ProgramRegistration",
      component: ProgramRegistration,
    },
    {
      path: "/reports",
      name: "Reports",
      component: Reports,
    },
    {
      path: "/state-contacts",
      name: "StateContacts",
      component: StateContacts,
    },
    {
      path: "/deliverers",
      name: "Deliverers",
      component: Deliverers,
    }
    ,
    {
      path: "/coordinators",
      name: "Coordinators",
      component: Coordinators,
    },
    {
      path: "/vouchers",
      name: "Vouchers",
      component: Vouchers,
    },
    {
      path: "/logout.aspx",
      name: "Logout",
      component: LogoutViewVue,
    },
    {
      path: "/participation/program/participants/:programUID/:programCategoryId?/:venueId?",
      name: "ParticipationProgramParticipants",
      component: ProgramParticipants,
    },
    {
      path: "/participation/program/email/:programUID/:programName?",
      name: "ParticipationProgramEmail",
      component: ProgramParticipantsEmail,
      props: true
    },
    {
      path: "/participation/program/send-email/:programUID",
      name: "ParticipationProgramSendEmail",
      component: ProgramParticipantsSendEmail,
    },
    {
      path: "/participation/program/select-participants/:programUID",
      name: "ProgramParticipantsSelection",
      component: ProgramParticipantsSelection,
    },
    {
      path: "/participation/program/register/:programUID/:rId?/:rdId?",
      name: "ParticipantsProgramRegistration",
      component: ProgramRegistration,
    },
    {
      path: "/:pathMatch(.*)*",
      name: "NotFound",
      component: PageNotFound,
    },
  ],
});

export default router;